// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".big {\n  width: 100%;\n  height: calc(100vh - 220px);\n  background-color: #f4f4f4;\n  position: relative;\n}\n.inner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.inner p {\n  text-align: center;\n  font-size: 24px;\n}\n.inner .leftPic {\n  width: 60px;\n  height: 60px;\n  margin-left: 44%;\n  margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
